import { render } from "./item_price_history_form.vue?vue&type=template&id=455d9d33&scoped=true"
import script from "./item_price_history_form.vue?vue&type=script&lang=js"
export * from "./item_price_history_form.vue?vue&type=script&lang=js"

import "./item_price_history_form.vue?vue&type=style&index=0&id=455d9d33&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455d9d33"]])

export default __exports__